module.exports = __webpack_public_path__ + "static/media/2-8.75d55df9.svg";